import React from 'react';
import './characteristics.css';

export default function Characteristics({characteristics}) {
 
  return (
    <div>
      <span>{characteristics}</span>
    </div>
  );
};